import { createContext, useContext, type ReactNode } from 'react';
import { Platform } from 'react-native';

const SelectFieldModalContext = createContext(false);

/** Mark descendants as rendered inside an RN Modal so SelectField avoids nested modal stacking on iOS. */
export function SelectFieldModalProvider({ children }: { children: ReactNode }) {
  return <SelectFieldModalContext.Provider value={true}>{children}</SelectFieldModalContext.Provider>;
}

export function useSelectFieldInsideModal(): boolean {
  return useContext(SelectFieldModalContext);
}

/** Expand pickers below the trigger when nested in a modal (web + iOS). */
export function useInlineSelectPicker(): boolean {
  const isInsideModal = useSelectFieldInsideModal();
  return isInsideModal && (Platform.OS === 'web' || Platform.OS === 'ios');
}
